<template>
  <v-row justify="center">
    <v-dialog v-model="dialogShown" v-if="user" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            ><b
              >Obnova članstva
              <span v-if="type == 'family'">(obitelj)</span>:</b
            >
            {{ user.FirstName }} {{ user.LastName }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <h3>Baza članstva</h3>
                <v-divider></v-divider>
                <v-select
                  required
                  :items="dphs"
                  item-text="Name"
                  item-value="Id"
                  :rules="validationRules.dph"
                  v-model="user.Primary_Affiliate__c"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" v-if="!fieldActivity && !loading">
                <p class="text-red">Greška! Ne postoji aktivna akcija.</p>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                v-if="!loading && invalidIdentifierMessage"
              >
                <p class="text-red">Greška! {{ invalidIdentifierMessage }}</p>
                <v-form
                  v-model="documentFormValid"
                  ref="documentForm"
                  lazy-validation
                >
                  <v-text-field
                    label="OIB"
                    required
                    v-model="newOib"
                    :rules="validationRules.oib"
                  >
                  </v-text-field>
                </v-form>
                <v-alert outlined text type="error" v-show="documentError">
                  {{ documentError }}
                </v-alert>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="updateDocument"
                  v-if="!documentLoading"
                >
                  Upiši
                </v-btn>
                <div v-else class="clearfix">
                  <div class="loading-progress">
                    <v-progress-circular
                      indeterminate
                      color="#1358a3"
                    ></v-progress-circular>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <h3>Način plaćanja</h3>
                <v-divider></v-divider>
                <v-select
                  required
                  :items="paymentMethods"
                  :rules="validationRules.paymentMethods"
                  v-model="paymentMethod"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="type == 'family'">
              <v-col cols="12" sm="12">
                <h3>Članovi obitelji</h3>
                <v-divider></v-divider>
                <RenewMembershipHouseholdMembers
                  :householdId="user.npsp__HHId__c"
                />
              </v-col>
            </v-row>

            <p class="membership-info-text">
              Ukupni iznos članarine (s popustom):
              <span class="amount">{{ membershipAmountFormatted }} €</span>
            </p>
            <v-divider></v-divider>
          </v-container>
        </v-card-text>

        <v-alert outlined text type="error" v-show="error">
          {{ error }}
        </v-alert>

        <v-alert outlined text type="warning" v-show="warning">
          {{ warning }}
        </v-alert>

        <v-alert
          outlined
          text
          type="success"
          v-show="success && success !== true"
        >
          {{ success }}
        </v-alert>

        <v-card-actions v-if="!loading">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeDialog"> Zatvori </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="renewMembership"
            v-show="
              !success &&
              fieldActivity &&
              !invalidIdentifierMessage &&
              (!error || !error.startsWith('Članarina je obnovljena'))
            "
          >
            Obnovi članstvo
          </v-btn>
        </v-card-actions>

        <div v-else class="clearfix">
          <div class="loading-progress">
            <v-progress-circular
              indeterminate
              color="#1358a3"
            ></v-progress-circular>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import apiRequest from "../../helpers/apiRequest";
import RenewMembershipHouseholdMembers from "./RenewMembershipHouseholdMembers.vue";
import mixin from "../../mixins/mixin";
import { isOibValid } from "../../helpers/validateMemberForm";

export default {
  name: "RenewMembershipDialog",

  components: { RenewMembershipHouseholdMembers },

  mixins: [mixin],

  data: () => ({
    validationRules: {
      dph: [(v) => !!v || "DPH nije odabran"],
      paymentMethod: [(v) => !!v || "Način plaćanja nije odabran"],
      oib: [
        (v) =>
          (this.user.Birthdate &&
            this.user.Birthdate >
              new Date(new Date().setDate(new Date().getDate() - 30))) ||
          (v && isOibValid(v)) ||
          "OIB nije ispravan",
      ],
    },
    year: new Date().getFullYear().toString(),
    newOib: "",
    activeFieldActivities: [],
    loading: false,
    documentLoading: false,
    error: false,
    documentError: false,
    success: false,
    documentSuccess: false,
    warning: false,
    paymentMethods: ["Bank Transfer", "Cash"],
    paymentMethod: "Bank Transfer",
    documentFormValid: false,
  }),

  watch: {
    async dialogShown(value) {
      if (value) {
        this.fetchFieldActivities();
      } else {
        this.year = new Date().getFullYear().toString();
      }
    },
  },

  computed: {
    dialogShown() {
      return this.$store.state.membershipRenewal.isDialogVisible;
    },

    user() {
      return this.$store.getters.mainMember;
    },

    type() {
      return this.$store.state.membershipRenewal.type;
    },

    dphs() {
      return this.$store.state.allDphs;
    },

    renewalMembers() {
      return this.$store.state.membershipRenewal.members;
    },

    invalidIdentifierMessage() {
      if (
        this.user.MailingCountry === "Croatia" &&
        !this.user.Tax_Number__c &&
        this.user.Birthdate &&
        this.user.Birthdate <
          new Date(new Date().setDate(new Date().getDate() - 30))
      )
        return "OIB je obavezan";

      return null;
    },

    // Vraća prvu aktivnu terensku akciju
    fieldActivity() {
      return this.activeFieldActivities && this.activeFieldActivities.length
        ? this.activeFieldActivities[0]
        : null;
    },

    membershipAmountFormatted() {
      const amount =
        this.type == "family"
          ? this.user.Account.Proposed_Membership_Amount_Total__c
          : this.user.Proposed_Membership_Amount_Formula__c;

      return this.formatCurrency(amount);
    },
  },

  methods: {
    async fetchFieldActivities() {
      this.activeFieldActivities = [];
      this.loading = true;

      try {
        this.activeFieldActivities = await apiRequest(
          "get",
          "field-activities/my/active"
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    async renewMembership() {
      this.resetFields();
      this.loading = true;

      try {
        if (this.type == "family") {
          await this.renewHouseholdMembership();
        } else {
          await this.renewSingleMembership();
        }
      } catch (error) {
        this.error = error.response.data.message;
      } finally {
        this.loading = false;
      }
    },

    async renewSingleMembership() {
      await apiRequest("post", `members/${this.user.Id}/new-membership`, {
        year: this.year,
        dphId: this.user.Primary_Affiliate__c,
        membershipAmount: this.user.Proposed_Membership_Amount_Formula__c,
        fieldActivity: this.fieldActivity,
        paymentMethod: this.paymentMethod,
      });

      this.success = "Članstvo uspješno obnovljeno!";
    },

    async renewHouseholdMembership() {
      let response = await apiRequest(
        "post",
        `households/${this.user.npsp__HHId__c}/new-household-membership`,
        {
          year: this.year,
          dphId: this.user.Primary_Affiliate__c,
          fieldActivity: this.fieldActivity,
          paymentMethod: this.paymentMethod,
        }
      );

      this.renewalMembers.forEach((member) => {
        let responseForThatMemberIndex = response.results.findIndex(
          (r) => r.contactId === member.Id
        );

        let responseForThatMember =
          responseForThatMemberIndex !== -1
            ? response.results[responseForThatMemberIndex]
            : null;

        this.$store.commit("setUserMembershipRenewalStatus", {
          memberId: member.Id,
          status:
            !responseForThatMember ||
            responseForThatMember.opportunityId !== "null"
              ? "success"
              : "error",
        });
      });

      if (
        response.results.find((contact) => contact.opportunityId === "null")
      ) {
        this.warning = `Došlo je do problema kod obnove članarine za neke od članova obitelji. 
          Ukupno naplaćeni iznos: ${response.total_price} €`;

        let reasons = response.results
          .map((r) => r["systemErr"])
          .filter((e) => e);

        if (reasons.length) {
          this.warning += ` Razlozi: ${reasons.join(", ")}`;
        }

        if (response.total_price > 0) this.success = true;
      } else {
        this.success = `Članstvo uspješno obnovljeno!  
          Ukupno naplaćeni iznos: ${response.total_price} €`;
      }
    },

    resetFields() {
      this.loading = false;
      this.documentLoading = false;
      this.error = false;
      this.documentError = false;
      this.success = false;
      this.documentSuccess = false;
      this.warning = false;
      this.documentFormValid = false;
    },

    closeDialog() {
      this.$store.dispatch("closeRenewMembershipDialog");

      if (
        this.success ||
        this.documentSuccess ||
        (this.error && this.error.startsWith("Članarina je obnovljena"))
      ) {
        this.$store.dispatch("completeMembershipRenewal");
      }

      this.resetFields();
    },

    async updateDocument(e) {
      e.preventDefault();
      this.$refs.documentForm.validate();

      if (this.documentFormValid) {
        this.resetFields();
        this.documentLoading = true;

        try {
          await apiRequest("patch", `members/document/${this.user.Id}`, {
            oib: this.newOib,
          });
          this.user.Tax_Number__c = this.newOib;
          this.newOib = "";
          this.$refs.documentForm.reset();
          this.documentSuccess = true;
        } catch (error) {
          this.documentError = error;
          this.documentFormValid = true;
        } finally {
          this.documentLoading = false;
        }
      }
    },
  },
  mounted() {
    this.newOib = "";
  },
};
</script>

<style lang="scss" scoped>
.error-text {
  margin-bottom: 0;
  padding-bottom: 20px;
}

.membership-info-text {
  font-weight: 600;
  text-align: right;

  .amount {
    font-weight: bold;
    font-size: 18px;
  }
}

.loading-progress {
  float: right;
  margin-right: 20%;
  min-height: 60px !important;
}

.v-alert {
  margin: 0 10px;
}
</style>
